module.exports = __webpack_public_path__ + "img/skycloudLogin.bbcf1243.png";